export default __webpack_public_path__ + "static/media/hospital.b0d710ff.jpg";